require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-zy-wx-06.json") })
        }
      }, "path---photos-professional-zy-wx-06");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-zy-wx-06!./.cache/json/photos-professional-zy-wx-06.json
// module id = 1240
// module chunks = 231608221292675